/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AllowedConfigs = 'AMI_NAME_IRR' | 'AMI_NAME_CDVX' | 'LAMBDA_ZIPFILE_NAME' | 'GCP_DEPLOYMENT_VERSION' | 'GCP_IRR_IMAGE_NAME' | 'GCP_CDVX_IMAGE_NAME' | 'GCP_CLOUDRUN_JOB_CONTAINER_IMAGE_NAME' | 'VMCFS_AMI_NAME_IRR' | 'VMCFS_AMI_NAME_CDVX' | 'VMCFS_LAMBDA_ZIPFILE_NAME' | 'CYBERVAULT_AMI_NAME_IRR' | 'CYBERVAULT_AMI_NAME_CDVX' | 'CYBERVAULT_LAMBDA_ZIPFILE_NAME' | 'CCM_SCAN_ENABLED_POLICIES' | 'CCM_CLEANUP_ENABLED_POLICIES' | 'ORG_SCAN_THREAD_DELAY_MS' | 'DEPLOYMENT_COMPLETION_DELAY_MS' | 'INVENTORY_QUEUE_MESSAGE_RETENTION_DAYS' | 'AGENT_PAIRING_CODES_LENGTH' | 'AGENT_PAIRING_CODES_VALIDITY_SECONDS' | 'AGENT_PAIRING_POLL_INTERVAL_SECONDS' | 'DPX_SRM_MINIMUM_SUPPORTED_AGENT_VERSION' | 'DPX_SRM_MINIMUM_SUPPORTED_SRM_VERSION' | 'ENFORCEMENT_MINIMUM_SUPPORTED_SRM_VERSION' | 'SDK18_SUPPORTED_MINIMUM_SRM_VERSION' | 'S3_EXPIRY_DURATION_DAYS' | 'CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_DEGRADED' | 'CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_SUSPENDED' | 'ACTIVATE_VLR_AGENT_JOB_EXPIRY_IN_HOURS' | 'TASKS_EVENTS_DB_FETCH_MAX_PAGE_SIZE' | 'EVS_CONSOLE_URL' | 'GCVE_CONSOLE_URL' | 'VCF_CSP_BACKEND_URL' | 'VCF_CSP_CONSOLE_URL' | 'VMC_CSP_BACKEND_URL' | 'VMC_CSP_CONSOLE_URL' | 'VMC_BACKEND_URL' | 'VMC_CONSOLE_URL' | 'VLR_CONSOLE_SETTINGS_URL_SUFFIX' | 'VMCFS_CONSOLE_SETTINGS_URL_SUFFIX' | 'VLR_CONSOLE_SETTINGS_VCS_URL_SUFFIX' | 'VLR_CONSOLE_SETTINGS_ENFORCEMENT_URL_SUFFIX' | 'VMCFS_CONSOLE_SETTINGS_ENFORCEMENT_URL_SUFFIX' | 'VLR_CONSOLE_SETTINGS_SDDC_VMC_URL_SUFFIX' | 'VMCFS_CONSOLE_SETTINGS_SDDC_VMC_URL_SUFFIX' | 'VLR_CONSOLE_SETTINGS_SDDC_EVS_URL_SUFFIX' | 'VLR_CONSOLE_SETTINGS_SDDC_GCVE_URL_SUFFIX' | 'VLR_CONSOLE_SETTINGS_EDR_CB_SUFFIX' | 'VLR_CONSOLE_SETTINGS_EDR_CS_SUFFIX' | 'ASUP_BACKEND_URL' | 'VLR_CONSOLE_URL' | 'VMCFS_CONSOLE_URL' | 'SP_BACKEND_URL' | 'VCF_SERVICE_ROLES_TO_ADD_VMC_USERS' | 'MANAGED_STATIC_RESOURCE_SUPPORTED_PROVIDERS' | 'MANAGED_DYNAMIC_RESOURCE_SUPPORTED_PROVIDERS' | 'MANAGED_SHARABLE_RESOURCE_SUPPORTED_PROVIDERS' | 'BYO_RESOURCE_SUPPORTED_PROVIDERS' | 'COMPONENT_CATEGORY_HEALTH_DETAILS_MAX_COUNT' | 'CHECK_FE_ON_UPGRADE_TIMEOUT' | 'GCP_EMAIL_CLOUD_RUN_FUNCTION_URL' | 'GCP_EMAIL_WORKLOAD_IDENTITY_POOL_ID' | 'GCP_EMAIL_WORKLOAD_IDENTITY_SERVICE_ACCOUNT_NAME' | 'VMC_USAGE_SCAN_FOR_NON_DEPLOYMENT_ORGS_DELAY_DAYS' | 'BILLING_SUBSCRIPTION_EXPIRING_NOTIFICATION_TRIGGER_DAYS' | 'NOTIFICATION_BATCH_SIZE' | 'ORG_TYPE_DEFAULT' | 'QUARTZ_SCHEDULER_INITIAL_DELAY_SECONDS' | 'NOTIFICATION_STATUS_CHECK_MAX_ATTEMPTS' | 'FLEET_ORCHESTRATOR_IRR_UPGRADE_CONCURRENCY_LIMIT' | 'FLEET_ORCHESTRATOR_IRR_GW_CERT_UPDATE_CONCURRENCY_LIMIT' | 'ENABLE_FEATURE_FLAG_AUDIT' | 'ENABLE_FEATURE_FLAG_NOTIFICATION' | 'ENABLE_FEATURE_FLAG_NOTIFICATION_STATUS_CHECK_LIMIT' | 'ENABLE_FEATURE_FLAG_INPUT_VALIDATION' | 'ENABLE_FEATURE_FLAG_RANSOMWARE_RECOVERY' | 'ENABLE_FEATURE_FLAG_ORG_SCAN_SCHEDULERS' | 'ENABLE_FEATURE_FLAG_ORG_MIGRATION' | 'ENABLE_FEATURE_FLAG_DYNAMIC_SCHEDULER' | 'ENABLE_FEATURE_FLAG_TASK_CANCELLATION' | 'ENABLE_FEATURE_FLAG_CACHING' | 'ENABLE_FEATURE_FLAG_FORWARD_STATS_TO_BILLING_ENGINE' | 'ENABLE_FEATURE_FLAG_TRIM_COMPONENT_HEALTH_DETAILS' | 'ENABLE_FEATURE_FLAG_ENABLE_PRE_UPGRADE_CHECK_API' | 'ENABLE_FEATURE_FLAG_IRR_POLLER' | 'ENABLE_FEATURE_FLAG_FAST_API_SUBSCRIPTION_SOURCE' | 'ENABLE_FEATURE_FLAG_PURGE_ORG_METADATA' | 'ENABLE_FEATURE_FLAG_IRR_QUOTA_PUSH_SCHEDULER' | 'ENABLE_FEATURE_FLAG_SDDC_SCANNER' | 'ENABLE_FEATURE_FLAG_GCP' | 'ENABLE_FEATURE_FLAG_GCP_SA_IMPERSONATION' | 'ENABLE_FEATURE_FLAG_SDDC_MANAGEMENT' | 'ENABLE_FEATURE_FLAG_GCP_CUSTOM_DEVELOPER_ROLE' | 'ENABLE_FEATURE_FLAG_GCP_CLOUDRUN_JOB_DELETION' | 'ENABLE_FEATURE_FLAG_IRR_PROXY_API_RETRY' | 'ENABLE_FEATURE_FLAG_VMC_HOST_USAGE' | 'ENABLE_FEATURE_FLAG_VMC_HOST_BURST_SYNC' | 'ENABLE_FEATURE_FLAG_SRM_ENFORCEMENT' | 'EXPIRED_BUCKETS_DELETION_SCAN_DAYS' | 'BOX_FILE_ID' | 'INCORTA_IGNORE_SKU_LIST' | 'INCORTA_ALLOWED_LINE_STATUS' | 'DRC_OAUTH_APP_ROTATION_MIN_WAIT_HOURS' | 'OAUTH_APPS_DELETION_GRACE_PERIOD_DAYS' | 'ENABLE_FEATURE_FLAG_CACHE_ORG_CAPABILITIES' | 'ENABLE_FEATURE_FLAG_CACHE_VCDS_ORGS' | 'ENABLE_FEATURE_FLAG_CACHE_GLOBAL_CAPABILITIES' | 'ENABLE_FEATURE_FLAG_CACHE_ORG_TYPE_CAPABILITIES' | 'USER_EMAIL_MAPPING_ENABLED' | 'USER_EMAIL_MAPPING_DOMAINS' | 'USER_PROFILE_SYNC_DELETION_THRESHOLD_DAYS' | 'SYSTEM_GENERATED_EMAIL_BCC_LIST';

export const AllowedConfigs = {

    AMI_NAME_IRR: 'AMI_NAME_IRR' as AllowedConfigs,

    AMI_NAME_CDVX: 'AMI_NAME_CDVX' as AllowedConfigs,

    LAMBDA_ZIPFILE_NAME: 'LAMBDA_ZIPFILE_NAME' as AllowedConfigs,

    GCP_DEPLOYMENT_VERSION: 'GCP_DEPLOYMENT_VERSION' as AllowedConfigs,

    GCP_IRR_IMAGE_NAME: 'GCP_IRR_IMAGE_NAME' as AllowedConfigs,

    GCP_CDVX_IMAGE_NAME: 'GCP_CDVX_IMAGE_NAME' as AllowedConfigs,

    GCP_CLOUDRUN_JOB_CONTAINER_IMAGE_NAME: 'GCP_CLOUDRUN_JOB_CONTAINER_IMAGE_NAME' as AllowedConfigs,

    VMCFS_AMI_NAME_IRR: 'VMCFS_AMI_NAME_IRR' as AllowedConfigs,

    VMCFS_AMI_NAME_CDVX: 'VMCFS_AMI_NAME_CDVX' as AllowedConfigs,

    VMCFS_LAMBDA_ZIPFILE_NAME: 'VMCFS_LAMBDA_ZIPFILE_NAME' as AllowedConfigs,

    CYBERVAULT_AMI_NAME_IRR: 'CYBERVAULT_AMI_NAME_IRR' as AllowedConfigs,

    CYBERVAULT_AMI_NAME_CDVX: 'CYBERVAULT_AMI_NAME_CDVX' as AllowedConfigs,

    CYBERVAULT_LAMBDA_ZIPFILE_NAME: 'CYBERVAULT_LAMBDA_ZIPFILE_NAME' as AllowedConfigs,

    CCM_SCAN_ENABLED_POLICIES: 'CCM_SCAN_ENABLED_POLICIES' as AllowedConfigs,

    CCM_CLEANUP_ENABLED_POLICIES: 'CCM_CLEANUP_ENABLED_POLICIES' as AllowedConfigs,

    ORG_SCAN_THREAD_DELAY_MS: 'ORG_SCAN_THREAD_DELAY_MS' as AllowedConfigs,

    DEPLOYMENT_COMPLETION_DELAY_MS: 'DEPLOYMENT_COMPLETION_DELAY_MS' as AllowedConfigs,

    INVENTORY_QUEUE_MESSAGE_RETENTION_DAYS: 'INVENTORY_QUEUE_MESSAGE_RETENTION_DAYS' as AllowedConfigs,

    AGENT_PAIRING_CODES_LENGTH: 'AGENT_PAIRING_CODES_LENGTH' as AllowedConfigs,

    AGENT_PAIRING_CODES_VALIDITY_SECONDS: 'AGENT_PAIRING_CODES_VALIDITY_SECONDS' as AllowedConfigs,

    AGENT_PAIRING_POLL_INTERVAL_SECONDS: 'AGENT_PAIRING_POLL_INTERVAL_SECONDS' as AllowedConfigs,

    DPX_SRM_MINIMUM_SUPPORTED_AGENT_VERSION: 'DPX_SRM_MINIMUM_SUPPORTED_AGENT_VERSION' as AllowedConfigs,

    DPX_SRM_MINIMUM_SUPPORTED_SRM_VERSION: 'DPX_SRM_MINIMUM_SUPPORTED_SRM_VERSION' as AllowedConfigs,

    ENFORCEMENT_MINIMUM_SUPPORTED_SRM_VERSION: 'ENFORCEMENT_MINIMUM_SUPPORTED_SRM_VERSION' as AllowedConfigs,

    SDK18_SUPPORTED_MINIMUM_SRM_VERSION: 'SDK18_SUPPORTED_MINIMUM_SRM_VERSION' as AllowedConfigs,

    S3_EXPIRY_DURATION_DAYS: 'S3_EXPIRY_DURATION_DAYS' as AllowedConfigs,

    CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_DEGRADED: 'CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_DEGRADED' as AllowedConfigs,

    CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_SUSPENDED: 'CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_SUSPENDED' as AllowedConfigs,

    ACTIVATE_VLR_AGENT_JOB_EXPIRY_IN_HOURS: 'ACTIVATE_VLR_AGENT_JOB_EXPIRY_IN_HOURS' as AllowedConfigs,

    TASKS_EVENTS_DB_FETCH_MAX_PAGE_SIZE: 'TASKS_EVENTS_DB_FETCH_MAX_PAGE_SIZE' as AllowedConfigs,

    EVS_CONSOLE_URL: 'EVS_CONSOLE_URL' as AllowedConfigs,

    GCVE_CONSOLE_URL: 'GCVE_CONSOLE_URL' as AllowedConfigs,

    VCF_CSP_BACKEND_URL: 'VCF_CSP_BACKEND_URL' as AllowedConfigs,

    VCF_CSP_CONSOLE_URL: 'VCF_CSP_CONSOLE_URL' as AllowedConfigs,

    VMC_CSP_BACKEND_URL: 'VMC_CSP_BACKEND_URL' as AllowedConfigs,

    VMC_CSP_CONSOLE_URL: 'VMC_CSP_CONSOLE_URL' as AllowedConfigs,

    VMC_BACKEND_URL: 'VMC_BACKEND_URL' as AllowedConfigs,

    VMC_CONSOLE_URL: 'VMC_CONSOLE_URL' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_URL_SUFFIX: 'VLR_CONSOLE_SETTINGS_URL_SUFFIX' as AllowedConfigs,

    VMCFS_CONSOLE_SETTINGS_URL_SUFFIX: 'VMCFS_CONSOLE_SETTINGS_URL_SUFFIX' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_VCS_URL_SUFFIX: 'VLR_CONSOLE_SETTINGS_VCS_URL_SUFFIX' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_ENFORCEMENT_URL_SUFFIX: 'VLR_CONSOLE_SETTINGS_ENFORCEMENT_URL_SUFFIX' as AllowedConfigs,

    VMCFS_CONSOLE_SETTINGS_ENFORCEMENT_URL_SUFFIX: 'VMCFS_CONSOLE_SETTINGS_ENFORCEMENT_URL_SUFFIX' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_SDDC_VMC_URL_SUFFIX: 'VLR_CONSOLE_SETTINGS_SDDC_VMC_URL_SUFFIX' as AllowedConfigs,

    VMCFS_CONSOLE_SETTINGS_SDDC_VMC_URL_SUFFIX: 'VMCFS_CONSOLE_SETTINGS_SDDC_VMC_URL_SUFFIX' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_SDDC_EVS_URL_SUFFIX: 'VLR_CONSOLE_SETTINGS_SDDC_EVS_URL_SUFFIX' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_SDDC_GCVE_URL_SUFFIX: 'VLR_CONSOLE_SETTINGS_SDDC_GCVE_URL_SUFFIX' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_EDR_CB_SUFFIX: 'VLR_CONSOLE_SETTINGS_EDR_CB_SUFFIX' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_EDR_CS_SUFFIX: 'VLR_CONSOLE_SETTINGS_EDR_CS_SUFFIX' as AllowedConfigs,

    ASUP_BACKEND_URL: 'ASUP_BACKEND_URL' as AllowedConfigs,

    VLR_CONSOLE_URL: 'VLR_CONSOLE_URL' as AllowedConfigs,

    VMCFS_CONSOLE_URL: 'VMCFS_CONSOLE_URL' as AllowedConfigs,

    SP_BACKEND_URL: 'SP_BACKEND_URL' as AllowedConfigs,

    VCF_SERVICE_ROLES_TO_ADD_VMC_USERS: 'VCF_SERVICE_ROLES_TO_ADD_VMC_USERS' as AllowedConfigs,

    MANAGED_STATIC_RESOURCE_SUPPORTED_PROVIDERS: 'MANAGED_STATIC_RESOURCE_SUPPORTED_PROVIDERS' as AllowedConfigs,

    MANAGED_DYNAMIC_RESOURCE_SUPPORTED_PROVIDERS: 'MANAGED_DYNAMIC_RESOURCE_SUPPORTED_PROVIDERS' as AllowedConfigs,

    MANAGED_SHARABLE_RESOURCE_SUPPORTED_PROVIDERS: 'MANAGED_SHARABLE_RESOURCE_SUPPORTED_PROVIDERS' as AllowedConfigs,

    BYO_RESOURCE_SUPPORTED_PROVIDERS: 'BYO_RESOURCE_SUPPORTED_PROVIDERS' as AllowedConfigs,

    COMPONENT_CATEGORY_HEALTH_DETAILS_MAX_COUNT: 'COMPONENT_CATEGORY_HEALTH_DETAILS_MAX_COUNT' as AllowedConfigs,

    CHECK_FE_ON_UPGRADE_TIMEOUT: 'CHECK_FE_ON_UPGRADE_TIMEOUT' as AllowedConfigs,

    GCP_EMAIL_CLOUD_RUN_FUNCTION_URL: 'GCP_EMAIL_CLOUD_RUN_FUNCTION_URL' as AllowedConfigs,

    GCP_EMAIL_WORKLOAD_IDENTITY_POOL_ID: 'GCP_EMAIL_WORKLOAD_IDENTITY_POOL_ID' as AllowedConfigs,

    GCP_EMAIL_WORKLOAD_IDENTITY_SERVICE_ACCOUNT_NAME: 'GCP_EMAIL_WORKLOAD_IDENTITY_SERVICE_ACCOUNT_NAME' as AllowedConfigs,

    VMC_USAGE_SCAN_FOR_NON_DEPLOYMENT_ORGS_DELAY_DAYS: 'VMC_USAGE_SCAN_FOR_NON_DEPLOYMENT_ORGS_DELAY_DAYS' as AllowedConfigs,

    BILLING_SUBSCRIPTION_EXPIRING_NOTIFICATION_TRIGGER_DAYS: 'BILLING_SUBSCRIPTION_EXPIRING_NOTIFICATION_TRIGGER_DAYS' as AllowedConfigs,

    NOTIFICATION_BATCH_SIZE: 'NOTIFICATION_BATCH_SIZE' as AllowedConfigs,

    ORG_TYPE_DEFAULT: 'ORG_TYPE_DEFAULT' as AllowedConfigs,

    QUARTZ_SCHEDULER_INITIAL_DELAY_SECONDS: 'QUARTZ_SCHEDULER_INITIAL_DELAY_SECONDS' as AllowedConfigs,

    NOTIFICATION_STATUS_CHECK_MAX_ATTEMPTS: 'NOTIFICATION_STATUS_CHECK_MAX_ATTEMPTS' as AllowedConfigs,

    FLEET_ORCHESTRATOR_IRR_UPGRADE_CONCURRENCY_LIMIT: 'FLEET_ORCHESTRATOR_IRR_UPGRADE_CONCURRENCY_LIMIT' as AllowedConfigs,

    FLEET_ORCHESTRATOR_IRR_GW_CERT_UPDATE_CONCURRENCY_LIMIT: 'FLEET_ORCHESTRATOR_IRR_GW_CERT_UPDATE_CONCURRENCY_LIMIT' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_AUDIT: 'ENABLE_FEATURE_FLAG_AUDIT' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_NOTIFICATION: 'ENABLE_FEATURE_FLAG_NOTIFICATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_NOTIFICATION_STATUS_CHECK_LIMIT: 'ENABLE_FEATURE_FLAG_NOTIFICATION_STATUS_CHECK_LIMIT' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_INPUT_VALIDATION: 'ENABLE_FEATURE_FLAG_INPUT_VALIDATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_RANSOMWARE_RECOVERY: 'ENABLE_FEATURE_FLAG_RANSOMWARE_RECOVERY' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_ORG_SCAN_SCHEDULERS: 'ENABLE_FEATURE_FLAG_ORG_SCAN_SCHEDULERS' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_ORG_MIGRATION: 'ENABLE_FEATURE_FLAG_ORG_MIGRATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_DYNAMIC_SCHEDULER: 'ENABLE_FEATURE_FLAG_DYNAMIC_SCHEDULER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_TASK_CANCELLATION: 'ENABLE_FEATURE_FLAG_TASK_CANCELLATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_CACHING: 'ENABLE_FEATURE_FLAG_CACHING' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_FORWARD_STATS_TO_BILLING_ENGINE: 'ENABLE_FEATURE_FLAG_FORWARD_STATS_TO_BILLING_ENGINE' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_TRIM_COMPONENT_HEALTH_DETAILS: 'ENABLE_FEATURE_FLAG_TRIM_COMPONENT_HEALTH_DETAILS' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_ENABLE_PRE_UPGRADE_CHECK_API: 'ENABLE_FEATURE_FLAG_ENABLE_PRE_UPGRADE_CHECK_API' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_IRR_POLLER: 'ENABLE_FEATURE_FLAG_IRR_POLLER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_FAST_API_SUBSCRIPTION_SOURCE: 'ENABLE_FEATURE_FLAG_FAST_API_SUBSCRIPTION_SOURCE' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_PURGE_ORG_METADATA: 'ENABLE_FEATURE_FLAG_PURGE_ORG_METADATA' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_IRR_QUOTA_PUSH_SCHEDULER: 'ENABLE_FEATURE_FLAG_IRR_QUOTA_PUSH_SCHEDULER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_SDDC_SCANNER: 'ENABLE_FEATURE_FLAG_SDDC_SCANNER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_GCP: 'ENABLE_FEATURE_FLAG_GCP' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_GCP_SA_IMPERSONATION: 'ENABLE_FEATURE_FLAG_GCP_SA_IMPERSONATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_SDDC_MANAGEMENT: 'ENABLE_FEATURE_FLAG_SDDC_MANAGEMENT' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_GCP_CUSTOM_DEVELOPER_ROLE: 'ENABLE_FEATURE_FLAG_GCP_CUSTOM_DEVELOPER_ROLE' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_GCP_CLOUDRUN_JOB_DELETION: 'ENABLE_FEATURE_FLAG_GCP_CLOUDRUN_JOB_DELETION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_IRR_PROXY_API_RETRY: 'ENABLE_FEATURE_FLAG_IRR_PROXY_API_RETRY' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_VMC_HOST_USAGE: 'ENABLE_FEATURE_FLAG_VMC_HOST_USAGE' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_VMC_HOST_BURST_SYNC: 'ENABLE_FEATURE_FLAG_VMC_HOST_BURST_SYNC' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_SRM_ENFORCEMENT: 'ENABLE_FEATURE_FLAG_SRM_ENFORCEMENT' as AllowedConfigs,

    EXPIRED_BUCKETS_DELETION_SCAN_DAYS: 'EXPIRED_BUCKETS_DELETION_SCAN_DAYS' as AllowedConfigs,

    BOX_FILE_ID: 'BOX_FILE_ID' as AllowedConfigs,

    INCORTA_IGNORE_SKU_LIST: 'INCORTA_IGNORE_SKU_LIST' as AllowedConfigs,

    INCORTA_ALLOWED_LINE_STATUS: 'INCORTA_ALLOWED_LINE_STATUS' as AllowedConfigs,

    DRC_OAUTH_APP_ROTATION_MIN_WAIT_HOURS: 'DRC_OAUTH_APP_ROTATION_MIN_WAIT_HOURS' as AllowedConfigs,

    OAUTH_APPS_DELETION_GRACE_PERIOD_DAYS: 'OAUTH_APPS_DELETION_GRACE_PERIOD_DAYS' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_CACHE_ORG_CAPABILITIES: 'ENABLE_FEATURE_FLAG_CACHE_ORG_CAPABILITIES' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_CACHE_VCDS_ORGS: 'ENABLE_FEATURE_FLAG_CACHE_VCDS_ORGS' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_CACHE_GLOBAL_CAPABILITIES: 'ENABLE_FEATURE_FLAG_CACHE_GLOBAL_CAPABILITIES' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_CACHE_ORG_TYPE_CAPABILITIES: 'ENABLE_FEATURE_FLAG_CACHE_ORG_TYPE_CAPABILITIES' as AllowedConfigs,

    USER_EMAIL_MAPPING_ENABLED: 'USER_EMAIL_MAPPING_ENABLED' as AllowedConfigs,

    USER_EMAIL_MAPPING_DOMAINS: 'USER_EMAIL_MAPPING_DOMAINS' as AllowedConfigs,

    USER_PROFILE_SYNC_DELETION_THRESHOLD_DAYS: 'USER_PROFILE_SYNC_DELETION_THRESHOLD_DAYS' as AllowedConfigs,

    SYSTEM_GENERATED_EMAIL_BCC_LIST: 'SYSTEM_GENERATED_EMAIL_BCC_LIST' as AllowedConfigs
};

